import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

export const TableHeaderRow = () => {
    const { t } = useTranslation();
    return (
        <TableRow>
            <TableCell >Emoji</TableCell>
            <TableCell>Task</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Completion Criteria</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>{t("goalConfigurationTemplates.bulkAssign.table.headerRow.assignedAthletes")}</TableCell>
            <TableCell padding="checkbox">Actions</TableCell>
        </TableRow>
    );
};
